import Button from "react-bootstrap/Button";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";

function NavScrollExample({ investmentPage, handleView }) {
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isBankvolePage = pathname === "/bankvole";

  const APP_STORE_URL = "https://apps.apple.com/ng/app/bankvole/id6478485232";
  const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.bankvole.app";

  const isMobileDevice = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const isApple = /iPad|iPhone|iPod/.test(ua) || ua.includes("Macintosh");
    const isAndroid = /android/i.test(ua);
    return { isApple, isAndroid };
  };

  const scrollToCta = () => {
    const ctaSection = document.getElementById("bv-cta");
    if (ctaSection) {
      ctaSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const gotoApply = () => {
    if (isBankvolePage) {
      const { isApple, isAndroid } = isMobileDevice();

      if (isApple && !window.MSStream) {
        window.open(APP_STORE_URL, "_blank");
      } else if (isAndroid) {
        window.open(PLAY_STORE_URL, "_blank");
      } else {
        // Desktop fallback — scroll to the CTA section on the page
        if (pathname === "/bankvole") {
          scrollToCta();
        } else {
          navigate("/bankvole#bv-cta");
        }
      }
    } else if (investmentPage) {
      handleView();
    } else {
      window.open("https://app.checkoff.finance/", "_blank");
    }
  };

  return (
    <div className="w-100 nav-b">
      <Navbar bg="white" expand="lg" expanded={isNavbarOpen}>
        <Container fluid className="">
          <Navbar.Brand className="nav-logo">
            <Link to={"/"}>
              <img
                src={`${process.env.PUBLIC_URL}/assets/icons/checkoff-logo.svg`}
                height={68}
                width={157}
                alt="logo"
              />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="navbarScroll"
            onClick={() => setIsNavbarOpen(!isNavbarOpen)}
            className=" border-0 noborder shadow-none"
          >
            {isNavbarOpen ? (
              <img
                src={`${process.env.PUBLIC_URL}/assets/icons/mobile-nav-icon.svg`}
                alt="logo"
              />
            ) : (
              <img
                src={`${process.env.PUBLIC_URL}/assets/icons/mobile-nav-icon.svg`}
                alt="logo"
              />
            )}
          </Navbar.Toggle>
          <Navbar.Collapse id="navbarScroll">
            <Link
              to="/loans"
              className="d-flex link nav-left-data width-100 margin-3"
              style={{ color: pathname === "/loans" ? "#C82290" : "#000" }}
            >
              Loans
            </Link>
            <Link
              to="/wealth-management"
              className="d-flex link nav-left-data width-100 margin-3"
              style={{ color: pathname === "/wealth-management" ? "#C82290" : "#000" }}
            >
              Wealth Management
            </Link>

            <Link
              to="/solar-financing"
              className="d-flex link nav-left-data width-100 margin-3"
              style={{ color: pathname === "/solar-financing" ? "#C82290" : "#000" }}
            >
              Solar Financing
            </Link>

            <Link
              to="/bankvole"
              className="d-flex link nav-left-data width-100 margin-3"
              style={{ color: pathname === "/bankvole" ? "#C82290" : "#000" }}
            >
              Bankvole
            </Link>

            <Nav
              className="me-auto my-2 my-lg-0 display-lap2"
              style={{ maxHeight: "100px" }}
              navbarScroll
            ></Nav>
            {/* <Link
              to="/testimonials"
              className="d-flex link nav-right-data width-100 margin-3"
              style={{ color: pathname === "/testimonials" ? "#C82290" : "#000" }}
            >
              Testimonials
            </Link> */}
            <Link
              to="/about-us"
              className="d-flex link nav-right-data width-100 margin-3"
              style={{ color: pathname === "/about-us" ? "#C82290" : "#000" }}
            >
              About Us
            </Link>
            <Link
              to="/contact-us"
              className="d-flex link nav-right-data width-100 margin-3"
              style={{ color: pathname === "/contact-us" ? "#C82290" : "#000" }}
            >
              Contact Us
            </Link>
            <Button
              onClick={gotoApply}
              className=" btn btn-primary text-secondary nav-right-btn width-100 p-3 shadow-none"
            >
              {isBankvolePage
                ? "Download App"
                : investmentPage
                ? "Get Started"
                : "Apply Now"}
            </Button>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}

export default NavScrollExample;